import React from 'react';
import { Card } from 'react-bootstrap';

const ComplementoOperacionesconderivadosResumen = ({ data = [], onEdit, onListChange }) => {

  // const handleEdit = (item) => {
  //   onEdit(item);
  // }

  // const handleDelete = (item) => {
  //   const newData = data.filter((value) => item.id !== value.id);

  //   onListChange(newData);
  // }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Operaciones con Derivados, Versión { data.Version }</Card.Subtitle>
        <br/>

        <strong className="text-info card-label-info">Monto ganancia acumulable: </strong>
        { data.MontGanAcum }
        <br/>

        <strong className="text-info card-label-info">Monto pérdida deducible: </strong>
        { data.MontPerdDed }
        <br/>
      </Card.Body>
    </Card>
  )
}

export default ComplementoOperacionesconderivadosResumen
